import styled from "styled-components";

interface TextStyle {
  bold?: boolean;
}

export const H1 = styled.h1`
  font-size: 32px;
  font-weight: 700;
  line-height: 42px;
`;

export const H2 = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
`;

export const H3 = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
`;

export const H4 = styled.h4`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
`;

export const H5 = styled.h5`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const TextBase = styled.p<TextStyle>`
  font-size: 16px;
  line-height: 170%;
  font-weight: ${({ bold }) => (bold ? 700 : 400)};
`;

export const TextSm = styled(TextBase)`
  font-size: 14px;
  line-height: 170%;
`;

export const TextXs = styled(TextBase)`
  font-size: 12px;
  line-height: 160%;
`;

export const Caption = styled(TextBase)`
  font-size: 10px;
  line-height: 160%;
`;
